// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 90 ? "add-to-homescreen" : chunkId) + "." + {"90":"a31fb692","248":"ceaf35e6","633":"3021c057"}[chunkId] + ".css";
};